const t=(t,e)=>{if(!t||0===t.length)return;let n=t[0],r=e(n);for(let l=1;l<t.length;l++){const o=e(t[l]);o>r&&(n=t[l],r=o)}return n};export{t as maxBy};
//# sourceMappingURL=maxBy.js.map
